import cx from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import MediaQuery from 'react-responsive';
import * as Modules from 'components/modules';
import { easeExpOut, easeCubicInOut } from 'd3-ease';
import { preloadImg } from 'helpers';
import { delay } from 'helpers';
import T from 'prop-types';
import React from 'react';
import { Animate } from 'react-move';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './flipper.css';

const Card = ({
  frontSide, img, children, ...props
}) => (
  <CSSTransition
    key={img.src}
    timeout={{ enter: 0, exit: 200 }}
    classNames="fade"
    {...props}
  >
    <div className={cx(frontSide ? styles.front : styles.back)}>
      <img className={styles.image} src={img.src} alt={img.alt} />
      {children}
    </div>
  </CSSTransition>
);

Card.propTypes = {
  frontSide: T.bool.isRequired,
  img: T.shape({
    src: T.string,
    alt: T.string,
  }).isRequired,
};

class Flipper extends React.Component {
  state = {
    card: this.props.dataArray[0].img,
    index: 0,
    whatToUse: 'index',
    frontCardSide: true,
    angle: 0,
  };

  componentDidMount() {
    this.props.dataArray.forEach(item => preloadImg(item.img.src));
  }

  getAngle = () => this.state.index * 180;

  getArrayIndex = i => Math.abs(i) % this.arrayLength;

  arrayLength = this.props.dataArray.length;

  // direction is equal to 1 or -1
  changeSlide = (direction) => {
    this.setState(
      prevState => ({
        index: prevState.index + 1 * direction,
        card: this.props.dataArray[
          Math.abs(prevState.index + 1 * direction) % this.arrayLength
        ].img,
        frontCardSide: !prevState.frontCardSide,
        whatToUse: 'index',
      }),
      () => this.props.slideChanged(this.getArrayIndex(this.state.index)),
    );
  };
  // direction is 1 or -1
  touchFlipper = (direction) => {
    Promise.resolve()
      .then(() => {
        this.setState(({ index }) => ({
          angle: index * 180 + 10 * direction,
          whatToUse: 'angle',
        }));
        return Promise.resolve();
      })
      .then(() => delay(500))
      .then(() => {
        this.setState(({ index }) => ({
          angle: index * 180,
          whatToUse: 'index',
        }));
      })
      .catch(e => console.log(e));
  };

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.touchFlipper([-1, 1][Math.floor(Math.random() * 2)]);
    }
  };


  render() {
    const { dots, dotsColor, intoView } = this.props;
    const {
      index, card, frontCardSide, angle, whatToUse,
    } = this.state;
    const arrayIndex = this.getArrayIndex(index);
    return (
      <div
        ref={(flipperContainer) => {
          this.flipperContainer = flipperContainer;
        }}
        className={styles.flipperСontainer}
        role="presentation"
      >
        <div>
          <MediaQuery maxWidth={1024}>
            <VisibilitySensor
              partialVisibility
              minTopValue={150}
              onChange={this.onVisibilityChange}
            >
              <div className={styles.sensor} />
            </VisibilitySensor>
          </MediaQuery>
        </div>
        <div className={styles.togglersContainer}>
          <button
            onClick={() => this.changeSlide(-1)}
            className={styles.togglerLeft}
            onMouseEnter={() => this.touchFlipper(-1)}
          />
          <button
            onClick={() => this.changeSlide(1)}
            className={styles.togglerRight}
            onMouseEnter={() => this.touchFlipper(1)}
          />
        </div>
        <Animate
          show
          start={() => ({
            y: 0,
          })}
          update={() =>
            (whatToUse === 'angle'
              ? {
                  y: [angle],
                  timing: { duration: 900, ease: easeExpOut },
                }
              : {
                  y: [this.getAngle()],
                  timing: { duration: 900, ease: easeExpOut },
                })}
        >
          {({ y }) => (
            <div
              style={{
                WebkitTransform: `rotateY(${y}deg)`,
                transform: `rotateY(${y}deg)`,
              }}
              className={styles.flipper}
            >
              <TransitionGroup timeout={{ enter: 0, exit: 200 }}>
                <Card key={card.src} frontSide={frontCardSide} img={card}>
                  {dots && (
                    <Modules.Dots
                      className={styles.dots}
                      quantity={this.arrayLength}
                      color={dotsColor}
                      activeIndex={arrayIndex}
                    />
                  )}
                </Card>
              </TransitionGroup>
            </div>
          )}
        </Animate>
        <Modules.SectionKeyHandlers
          arrowRightHandler={() => {
            this.changeSlide(1);
          }}
          arrowLeftHandler={() => {
            this.changeSlide(-1);
          }}
          active={intoView}
        />
      </div>
    );
  }
}

Flipper.propTypes = {
  dots: T.bool.isRequired,
  dataArray: T.arrayOf(T.shape({ src: T.string, alt: T.string })).isRequired,
  dotsColor: T.string.isRequired,
  intoView: T.bool.isRequired,
  slideChanged: T.func.isRequired,
};

export default Flipper;



// WEBPACK FOOTER //
// ./src/components/modules/FlipperSection/Flipper.js